import IndustryBodyCard from "../reusables/IndustryBodyCard";
import aviation from "../../assets/images/industries/aviation.svg";
import biz from "../../assets/images/industries/business.svg";
import construction from "../../assets/images/industries/construction.svg";
import ecommerce from "../../assets/images/industries/ecommerce.svg";
import education from "../../assets/images/industries/education.svg";
import health from "../../assets/images/industries/healthcare.svg";
import hospitality from "../../assets/images/industries/hospitality.svg";
import ngo from "../../assets/images/industries/ngo.svg";
import SolutionsNtunaCTA from "../solutions/SolutionsNtunaCTA";
import { Slide } from "react-reveal";

const IndustriesBody = () => {
  return (
    <section className="page industries box-shadow">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="page-head section-spacing-20 width-800 margin-auto">
              <p className="page-content-subtitle font-inter-regular">
                NTUNA.COM delivers tailored web and ICT solutions designed to
                solve real challenges, improve efficiency and drive growth
                across diverse industries.
              </p>
            </div>
            <div className="section-body">
              <div className="separated-page-section section-spacing-50">
                <Slide top>
                  <h2 className="ntuna-text-fill">
                    Industry Experience & Expertise
                  </h2>
                </Slide>

                <div className="separated-paragraphs-container flex">
                  <p>
                    NTUNA.COM proudly has over 10 years delivering web and ICT
                    solutions to businesses and organizations in diverse
                    industries.
                  </p>
                  <p>
                    Our approach is to deliver customized, high-performance
                    solutions tailored to the specific needs of each client we
                    serve.
                  </p>
                </div>
              </div>
              <div className="industries-content section-spacing-50">
                <ul className="industries-body-cards-container">
                  <IndustryBodyCard
                    icon={biz}
                    title="Businesses & Companies"
                    subtitle="We help businesses and companies streamline operations, improve digital presence and implement scalable ICT systems for growth and efficiency."
                  />
                  <IndustryBodyCard
                    icon={ecommerce}
                    title="E-commerce & Retail"
                    subtitle="We build high-performance platforms and systems than enhance customer experience, drive sales and support business scalability."
                  />
                  <IndustryBodyCard
                    icon={education}
                    title="Education & Schools"
                    subtitle="We help schools setup ICT infrastructure, digital platforms and systems that support modern learning environments and institutional growth."
                  />
                  <IndustryBodyCard
                    icon={aviation}
                    title="Travel & Tourism"
                    subtitle="We setup digital platforms, bookings systems and marketing solutions that enhance visibility, customer engagement and operational efficiency. "
                  />
                  <IndustryBodyCard
                    icon={ngo}
                    title="NGOs & Non-profits"
                    subtitle="We help NGOs and Non-profits setup professional web and social media presence that improve their outreach, credibility and impact."
                  />
                  <IndustryBodyCard
                    icon={construction}
                    title="Construction & Logistics"
                    subtitle="We help construction & logistics companies setup their digital and ICT infrastructure for their operational efficiency and security."
                  />
                  <IndustryBodyCard
                    icon={health}
                    title="Healthcare"
                    subtitle="We help health facilities setup their digital platforms and ICT systems and infrastructure to enhance their web presence and facility management."
                  />
                  <IndustryBodyCard
                    icon={hospitality}
                    title="Hospitality"
                    subtitle="We help hotels, resorts and lodges setup their digital presence and ICT solutions that improve bookings, customer experience and service delivery."
                  />
                </ul>
                <div className="section-footer center width-600 margin-auto section-spacing-50">
                  <p className=" margin-bottom-20 ntuna-dark-secondary">
                    See how we've delivered results for clients across
                    industries
                  </p>
                  <Slide top>
                    <a
                      href="/case-studies"
                      target="_blank"
                      rel="noopener noreferrer"
                      className=" button subcta uppercase"
                    >
                      Case Studies &rarr;
                    </a>
                  </Slide>
                </div>
              </div>
              <Slide top>
                <div className=" section-spacing-50">
                  <SolutionsNtunaCTA />
                </div>
              </Slide>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesBody;
